<script>

    import {onMount} from "svelte";
    import gsap from 'gsap';
    import {labels, mainTimeline} from "../../timelines/main-timeline";

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    const {leadersStart, leadersEnd} = labels;

    const images = Array.from(new Array(9)).map((_, i) => `images/person${i+1}@2x.png`);
    const widths = [155, 221, 211, 171, 207, 126, 139, 196, 215].map(n => n * 0.6);
    const x = [746, 862, 984, 1093, 1208, 812, 915, 1042, 1158].map(x => x - 80);
    const y = [481, 473, 479, 481, 476, 678, 684, 682, 683].map(y => y - 40);

    const getSelector = (i) => '.person' + i;

    const subLabels = ['leadersStart+=4', ...Array.from(new Array(8)).map((_, i) => 'leaders' + i)];
    const subOutLabels = function() {
        let labs = [...subLabels, leadersEnd];
        labs.shift();
        return labs;
    }();

    onMount(() => {

        images.forEach((_, i) => {
            inTimeline.to(getSelector(i), {
                opacity: 1,
                duration: 0.065,
            }).to(getSelector(i), {
                opacity: 0,
                duration: 0.065,
            }).to(getSelector(i), {
                opacity: 1,
                duration: 0.065,
            });



            const randomOffset = Math.random() * 0.8;

            mainTimeline.to(getSelector(i), {
                filter: 'url(#linear)',
                duration: 0.5,
            }, subLabels[i])
                .to(getSelector(i), {
                    filter: 'none',
                    duration: 0.01,
                 })
                .to(getSelector(i), {
                    filter: 'url(#linear)',
                    duration: 0.01,
                 })
                .to(getSelector(i), {
                    filter: 'none',
                    duration: 0.01,
                 })
                .to(getSelector(i), {
                    filter: 'url(#linear)',
                    duration: 0.01,
                });

            mainTimeline.to(getSelector(i), {
                    filter: 'none',
                    duration: 0.01,
                }, subOutLabels[i])
                .to(getSelector(i), {
                    filter: 'url(#linear)',
                    duration: 0.01,
                 })
                .to(getSelector(i), {
                    filter: 'none',
                    duration: 0.01,
                });

            outTimeline.to(getSelector(i), {
                opacity: 0,
                duration: 0.065,
            }, randomOffset).to(getSelector(i), {
                opacity: 1,
                duration: 0.065,
            }, '>').to(getSelector(i), {
                opacity: 0,
                duration: 0.065,
            }, '>');
        });

        mainTimeline.add(inTimeline, leadersStart);
        mainTimeline.add(outTimeline, leadersEnd);
    });

</script>

<g>
    <filter id="linear">
        <feColorMatrix
                type="matrix"
                values="1 0 0 0 0
              -0.4 0.8 0.1 0.1 -0.1
              -0.2 0.2 0.1 0.4 0
              0 0 0 1 0 "/>
    </filter>
    {#each images as src, i}
        <image href={src} class={' person person' + i} x={x[i] + 'px'} y={y[i]  + 'px'} width={widths[i]}/>
    {/each}
</g>

<style>
    .person {
        opacity: 0;
    }
</style>